import React, { createContext, useContext, useState, useEffect } from 'react';

// Crear el contexto
const BranchofficesByEventContext = createContext();

// Hook para usar el contexto fácilmente
export const useBranchofficesByEvent = () => useContext(BranchofficesByEventContext);

// Provider
export const BranchofficesByEventProvider = ({ children }) => {
  const [branchofficesByEvent, setBranchofficesByEvent] = useState(() => {
    const stored = localStorage.getItem('branchofficesByEvent');
    return stored ? JSON.parse(stored) : null;
  });

  // Sincronizar con cambios en localStorage (evento storage)
  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === 'branchofficesByEvent') {
        setBranchofficesByEvent(event.newValue ? JSON.parse(event.newValue) : null);
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  // Si quieres también detectar cambios locales (en la misma pestaña)
  useEffect(() => {
    const interval = setInterval(() => {
      const current = localStorage.getItem('branchofficesByEvent');
      setBranchofficesByEvent(current ? JSON.parse(current) : null);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // Función para actualizar el valor y localStorage
  const updateBranchofficesByEvent = (value) => {
    setBranchofficesByEvent(value);
    localStorage.setItem('branchofficesByEvent', JSON.stringify(value));
  };

  return (
    <BranchofficesByEventContext.Provider value={{ branchofficesByEvent, setBranchofficesByEvent: updateBranchofficesByEvent }}>
      {children}
    </BranchofficesByEventContext.Provider>
  );
};
